import React from 'react';
import SubHeader from 'components/general/SubHeader/SubHeader';
import Card from 'components/general/Card/Card';
import SEOMeta from 'containers/SEOMeta';
import GlobalAlertsList from './containers/GlobalAlertsList';
import GlobalArticlesList from './containers/GlobalArticlesList';
import UserContent from './containers/UserContent';
import DashboardPageHeader from './containers/DashboardPageHeader';

const Dashboard = () => (
  <div data-test="page-dashboard">
    <SEOMeta title="Dashboard" />
    <DashboardPageHeader />
    <UserContent />
    <div className="page-section page-section--dark l-dashboard">
      <Card>
        <Card.Section>
          <SubHeader
            title="Latest global alerts"
            action={{
              title: 'View all global alerts',
              icon: 'bell',
              to: {
                type: 'ALERTS_INDEX',
              },
            }}
          />
          <GlobalAlertsList />
        </Card.Section>
      </Card>
      <Card>
        <Card.Section>
          <SubHeader
            title="Latest global articles"
            action={{
              title: 'View all global articles',
              icon: 'bell',
              to: {
                type: 'ARTICLES_INDEX',
              },
            }}
          />
          <GlobalArticlesList />
        </Card.Section>
      </Card>
    </div>
  </div>
);

export default Dashboard;
